import { Theme } from "./theme"

export const lightTheme: Theme = {
  name: "light",
  colors: {
    bodyBg: "#FBFBFB",
    bg: "white",
    fg20: "rgba(0, 0, 0, 0.2)",
    fc: "#333332",
    iconBg: "rgba(0, 0, 0, 0.15)",
    nftDetailFrame: "white",
    iconButtonFont: "#5c5b59",
    btnBg: "#ededed",
    bigCavets: "#EDEDED",
  },
}
